import axios from "axios"
import store from "./store"

var isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

var paramsAxios = {
  baseURL: isDev ? '' : (process.env.VUE_APP_API_URL || ''),
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/x..v1+json"
  }
}

let api = axios.create(paramsAxios)

// Request interceptor - adicionar JWT token
api.interceptors.request.use(
  config => {
    store._actions["loader/loading"][0](true)
    
    // Adicionar token JWT se existir
    const token = store.state.auth ? store.state.auth.token : null
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    return config
  },
  error => {
    store._actions["loader/loading"][0](false)
    return Promise.reject(error)
  }
)

// Response interceptor
const errorHandler = async error => {
  store._actions["loader/loading"][0](false)
  
  const e = {
    responseText: error.request ? error.request.responseText : '',
    responseURL: error.request ? error.request.responseURL : '',
    status: error.request ? error.request.status : 0,
    statusText: error.request ? error.request.statusText : '',
    requestwithCredentials: error.request ? error.request.withCredentials : false
  }

  // Token expirado ou inválido - limpar auth e redirecionar
  if (error.response && (error.response.status === 401 || error.response.status === 403)) {
    if (store._actions["auth/clearAuth"]) {
      store._actions["auth/clearAuth"][0]()
    }
    window.location.href = "/"
  } else {
    store._actions["msgErro/exibirMsgErro"][0]()
  }

  return Promise.reject(e)
}

const successHandler = response => {
  store._actions["loader/loading"][0](false)
  return response
}

api.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error)
)

export const AXIOS = api


// WEBPACK FOOTER //
// ./src/http-common.js